import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const Profile = () => {
	return <div>Profile</div>;
};

export default Profile;
